import styled from 'styled-components';

export const StyledSelectInfoModal = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.24);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 2;

  .sim-wrapper {
    width: 335px;
    padding: 32px 76px;
    border-radius: 8px;
    /* background: rgba(0, 0, 0, 0.7); */

    &-top {
      margin-bottom: 20px;
      width: 100%;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;

      > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &-middle {
      font-size: 20px;
      font-weight: 700;
      line-height: 21.25px;
      text-align: center;
      color: #000;
    }
  }
`;
